import React from 'react'
import { BoundActionCreator } from '@sendoutcards/core'
// @src imports
import { connect } from 'src/redux/connect'
import {
  clearStorefront,
  loadedStorefront,
  loadedStorefrontError,
} from 'src/redux/actions/storefront'
import { openPayment } from 'src/redux/actions/payments'
import { PurchaseTypes } from 'src/payments/containers/Payment'
import { Item } from 'src/campaign_store/types'
import { openCatalog } from 'src/redux/actions/routeAliases'
import { Icon, Transition, VideoModal } from 'src/chrome'
import {
  MobilePricingTable,
  PricingTable,
} from 'src/marketing/plans/components'
import {
  HeroSection,
  SponsorBar,
  VideoRibbon,
  VideoSection,
} from 'src/marketing/storefront/components'
import { VideoObject } from 'src/marketing/storefront/components/VideoRibbon/VideoRibbon'
import { ProductPreviewModal } from 'src/campaign_store/components'
import { Plan } from 'src/marketing/plans/types'
import { AccountFragment, Category, Maybe, PlanFragment } from 'src/graphql'
import { getPlan } from 'src/helpers'
import {
  mobilePricingTableData,
  pricingTableData,
} from 'src/redux/selectors/plans'
import { FunnelPageRoute } from 'src/marketing/storefront/routes/FunnelPageRoute'

import planStyles from '../../plans/containers/plans.module.scss'
import styles from './storefront.module.scss'
import { openApp } from 'src/helpers/appHelpers'

type StorefrontActions = {
  loadedStorefrontError: BoundActionCreator<typeof loadedStorefrontError>
  clearStorefront: BoundActionCreator<typeof clearStorefront>
}

type PaymentsActions = {
  openPayment: BoundActionCreator<typeof openPayment>
}

type RoutesActions = {
  openCatalog: () => void
}

type StorefrontProps = {
  sponsorSlug?: string
  storefront?: {
    user: Partial<AccountFragment>
  }
  currentPlan: PlanFragment | false
  screenWidth: number
  pricingInfo?: Category[] | null
  plans?: PlanFragment[]
  mobilePricingInfo: Plan[] | null
  showSponsorBar: boolean
  route: FunnelPageRoute
} & StorefrontActions &
  PaymentsActions &
  RoutesActions

interface StorefrontState {
  activeItem?: Maybe<Item>
  selectedTutorial?: Maybe<VideoObject>
  downgrade?: string
  selectedPlan?: Plan
  cancelSubscription: boolean
  joinModal: boolean
  canceling: boolean
  selectedItem: Item | null
  isAffiliate: boolean
  toAffiliateForm: boolean
}

const initialState: StorefrontState = {
  selectedTutorial: null,
  cancelSubscription: false,
  joinModal: false,
  canceling: false,
  selectedItem: null,
  isAffiliate: false,
  toAffiliateForm: false,
}

class Storefront extends React.Component<StorefrontProps, StorefrontState> {
  state: StorefrontState = { ...initialState }

  onSelectVideo = (video: VideoObject) =>
    this.setState({ selectedTutorial: video })

  onDestructVideo = () => this.setState({ selectedTutorial: null })

  showPlanUpgrade = (planTitle: string) => {
    const { plans } = this.props
    const { selectedPlan } = this.state

    const plan =
      (plans && plans.find(p => p.title === planTitle)) || selectedPlan
    if (!plan) {
      return
    }
    openApp('pricing', { join: '', plan: plan.title })
  }

  closeProductPreview = () => {
    this.setState({ activeItem: null })
  }
  purchase = (item: any) => {
    if (this.props.openPayment) {
      this.props.openPayment({
        items: [item],
        purchaseType: PurchaseTypes.ITEMS,
      })
    }
  }

  closeAffiliateForm = () => {
    this.setState({
      isAffiliate: false,
    })
  }

  handleAffiliate = () => {
    openApp('pricing', { join: '', affiliate: '' })
  }

  joinSuccess = () => {
    this.setState({ joinModal: false })
    if (this.state.toAffiliateForm) {
      this.handleAffiliate()
    }
  }

  handleError = () => {
    this.setState({ ...initialState })
  }

  handleAddonPurchase = (name: string) => {
    openApp()
  }

  getPlan = (planId: string): PlanFragment | undefined =>
    getPlan(this.props.plans, planId)

  canPurchaseAddon = () => {
    const { currentPlan } = this.props
    return currentPlan && currentPlan.isLimited
  }

  // tslint:disable-next-line: cyclomatic-complexity score 23
  render() {
    const { storefront, currentPlan, showSponsorBar } = this.props
    const { activeItem, selectedTutorial, canceling } = this.state
    const theme =
      'rgba(0, 0, 0, 0) radial-gradient(circle at left bottom, rgb(212, 64, 214) 42%, rgb(32, 146, 250)) repeat scroll 0% 0%'
    const themeRight =
      'rgba(0, 0, 0, 0) radial-gradient(circle at left bottom, rgb(37, 149, 251) 10%, rgb(212, 64, 214)) repeat scroll 0% 0%'

    return (
      <div className={styles.storefrontContainer}>
        {showSponsorBar && storefront && <SponsorBar account={storefront} />}
        {/* Header Component  */}
        <header className={styles.siteHeader} style={{ margin: '25px 0' }}>
          <div className={styles.container}>
            <div className={styles.siteHeaderInner}>
              <div className={styles.brandHeader}>
                <h1 style={{ margin: 0 }}>
                  {/* eslint-disable-next-line */}
                  <a href={''}>
                    <Icon
                      icon={'SOCLOGO'}
                      viewBox={'0 0 77 72'}
                      size={39}
                      color={'#e687ff'}
                    />
                  </a>
                </h1>
              </div>
            </div>
          </div>
        </header>
        {/* EndHeader Component  */}
        <main>
          {/* Hero Section */}
          <HeroSection
            title={'Welcome to SendOutCards!'}
            copy={
              'Whether you are thanking someone for their business, telling someone you’re thinking of them, or sending holiday cards, there are endless opportunities to tangibly reach out to others with the SendOutCards system.'
            }
            withIframe={true}
            video={
              'https://fast.wistia.net/embed/iframe/jfxqo8qww0?videoFoam=true'
            }
            callToAction={{
              title: 'Send a Card',
              action: () => this.props.openCatalog(),
            }}
            style={{
              paddingTop: 192,
              marginTop: 1,
              marginBottom: 20,
              paddingBottom: 192,
              boxShadow: '0 4px 11px 0 #b2b7bc',
              background: '#f4f6fa',
            }}
          />
          {/* End Section */}
          <section className={styles.feature}>
            <VideoSection
              title={'How to Send a Card'}
              video={
                'https://fast.wistia.net/embed/iframe/7n19sssvzh?videoFoam=true'
              }
              withIframe={true}
              description={
                'We know the impact a simple greeting card can have in the world, we also know how important it is to get your message into the hands of the people who are going to receive it. SendOutCards amazing card sending platform makes it easy to act on your promptings everyday.'
              }
              theme={theme}
            />
          </section>
          <section className={styles.feature} style={{ marginBottom: 0 }}>
            <h1 className={styles.sectionHeading}>
              Tour the Website
              <p>2 Ways to Send Cards</p>
            </h1>
            <VideoSection
              title={'Heartfelt Prompting Card'}
              description={
                'This is a card sent with a heartfelt message to a single recipient with an immediate send date. This can be a sympathy card, congratulations card, a thank you card and many more. We feel this is the most important card since you are reaching out to someone in a heartfelt way and showing them you care.'
              }
              withIframe={true}
              video={
                'https://fast.wistia.com/embed/iframe/dkvswdostu?videoFoam=true'
              }
              loop={true}
              theme={theme}
            />
            <VideoSection
              right={true}
              title={'System Sends'}
              description={
                'The System Card Send is any card that is sent to multiple recipients (invitations, holiday cards, etc), card sent out on specific dates, or campaign sent to specific groups of people triggered by certain dates (birthday, anniversary, holiday, etc).'
              }
              withIframe={true}
              video={
                'https://fast.wistia.com/embed/iframe/x9gik4650s?videoFoam=true'
              }
              theme={themeRight}
            />
            <VideoSection
              title={'Campaign Store Overview'}
              description={
                'You can purchase perfectly curated campaigns, created for many niche networks available in our new Campaign Store! These campaigns include many different sized touch campaigns that you can purchase, perfect for your business. Add your handwriting and signatures as well to make your cards even more personal!'
              }
              withIframe={true}
              video={
                'https://fast.wistia.net/embed/iframe/kcgggx2qiw?videoFoam=true'
              }
              theme={theme}
            />
          </section>
          <section
            className={styles.feature}
            style={{ padding: '0 50px 180px', marginBottom: 0 }}
          >
            <h1 className={styles.sectionHeading}>Pricing</h1>
            <div
              className={`${planStyles.pricingTableContainer} ${planStyles.desktopTable}`}
            >
              {this.props.plans && this.props.pricingInfo && (
                <PricingTable
                  categories={this.props.pricingInfo}
                  account={undefined}
                  plans={this.props.plans}
                  currentPlanId={currentPlan ? currentPlan.id : ''}
                  onSelect={this.showPlanUpgrade}
                  stripeSubscription={undefined}
                  getPlan={this.getPlan}
                />
              )}
            </div>
            <div
              className={`${planStyles.pricingTableContainer} ${planStyles.mobileTable}`}
            >
              {this.props.mobilePricingInfo && (
                <MobilePricingTable
                  account={undefined}
                  plans={this.props.mobilePricingInfo}
                  currentPlan={currentPlan ? currentPlan.id : ''}
                  onSelect={this.showPlanUpgrade}
                  stripeSubscription={undefined}
                  getPlan={this.getPlan}
                />
              )}
            </div>
          </section>
          <section
            className={styles.feature}
            style={{ padding: '0 50px 50px', marginTop: 8 }}
          >
            <h1
              className={styles.sectionHeading}
              style={{
                marginBottom: 55,
                paddingTop: 50,
                fontSize: 28,
                lineHeight: '25px',
              }}
            >
              See What Others Are Saying
            </h1>
            <VideoRibbon onPlay={this.onSelectVideo} hideTitle={true} />
          </section>
        </main>
        {selectedTutorial && (
          <VideoModal video={selectedTutorial} onClose={this.onDestructVideo} />
        )}
        {canceling && <Transition message={'Downgrading Subscription'} />}
        {activeItem && (
          <ProductPreviewModal
            product={activeItem}
            onClose={this.closeProductPreview}
            onPurchase={this.purchase}
          />
        )}
      </div>
    )
  }
}

export default connect(
  state => {
    const { categories, features, plans } = state.plans
    const filteredPlans = plans.filter(p => p.features && p.features.length > 0)

    const pricingInfo = pricingTableData(categories, features, filteredPlans)
    const mobilePricingInfo = mobilePricingTableData(
      categories,
      features,
      filteredPlans,
    )
    return {
      ...state.storefront,
      pricingInfo,
      mobilePricingInfo,
      plans: filteredPlans,
      currentPlan: false as false,
      screenWidth: state.window.width,
    }
  },
  {
    loadedStorefront,
    loadedStorefrontError,
    clearStorefront,
    openCatalog,
    openPayment,
  },
)(Storefront)
